
document.addEventListener('DOMContentLoaded', function() {

  function updateCartBubble(totalItems) {
    const bubble = document.querySelector('.crt-tyioi');
    if (bubble) bubble.textContent = totalItems;
  }

 function refreshCartCount() {
    fetch('/cart.js')
      .then(resp => resp.json())
      .then(cart => {
        updateCartBubble(cart.item_count);
      });
  } 

  // Variant Change Handler
  document.querySelectorAll('.variant-select').forEach(select => {
    if (!select.classList.contains('bound')) {
      select.classList.add('bound');
      select.addEventListener('change', function() {
        const productId = this.getAttribute('data-product-id');
        const selectedOption = this.options[this.selectedIndex];
        const priceElement = document.querySelector(`#price-${productId}`);
        const hiddenInput = document.querySelector(`#hidden-variant-id-${productId}`);

        if (priceElement) priceElement.innerHTML = selectedOption.getAttribute('data-price');
        if (hiddenInput) hiddenInput.value = selectedOption.value;
      });
    }
  });

  // Add-to-Cart Button Handler
  document.querySelectorAll('.add-to-cart-btn').forEach(button => {
    if (!button.classList.contains('bound')) {
      button.classList.add('bound');

      button.addEventListener('click', function() {
        const form = this.closest('.add-to-cart-form');
        const productId = form.getAttribute('data-product-id');
        const variantInput = form.querySelector(`#hidden-variant-id-${productId}`);
        if (!variantInput) return;

        const variantId = variantInput.value;

        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: 1 })
        })
        .then(resp => resp.json())
        .then(() => {
          // Show success message
          const successMsg = document.querySelector(`#cart-success-${productId}`);
          if (successMsg) {
            successMsg.style.display = 'block';
            setTimeout(() => { successMsg.style.display = 'none'; }, 2000);
          }

          // Refresh header bubble from actual cart
          refreshCartCount();
        })
        .catch(err => {
          console.error('Error adding to cart:', err);
          alert('An error occurred. Please try again.');
        });
      });
    }
  });

  // Refresh header bubble on page load
  refreshCartCount();

});
